module.exports = __webpack_public_path__ + "img/img-1.0025a902.png";